import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { heroSlides } from "@/mocks/site";

export default function HeroCarousel() {
  const [index, setIndex] = useState(0);
  const [keyword, setKeyword] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setInterval(() => {
      setIndex((i) => (i + 1) % heroSlides.length);
    }, 5500);
    return () => clearInterval(timer);
  }, []);

  const go = (dir: number) =>
    setIndex((i) => (i + dir + heroSlides.length) % heroSlides.length);

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    const q = keyword.trim();
    if (!q) return;
    navigate(`/roles?q=${encodeURIComponent(q)}`);
  };

  return (
    <section className="relative h-[480px] w-full overflow-hidden md:h-[600px]">
      {heroSlides.map((slide, i) => (
        <div
          key={slide.id}
          className={`absolute inset-0 transition-opacity duration-700 ${
            i === index ? "opacity-100" : "opacity-0"
          }`}
        >
          <img
            src={slide.image}
            alt={`${slide.title} 萝莉动漫主题焦点图`}
            title={`${slide.title} - 萝莉动漫主题站`}
            className="h-full w-full object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/75 via-foreground-950/45 to-foreground-950/20"></div>
        </div>
      ))}

      <div className="relative z-10 mx-auto flex h-full max-w-[1280px] flex-col justify-center px-4 md:px-6">
        <div key={index} className="max-w-2xl animate-fade-up">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-500/90 px-3 py-1 text-xs font-medium text-background-50">
            <i className="ri-fire-fill"></i>
            {heroSlides[index].badge}
          </span>
          <h1 className="mt-4 text-3xl leading-tight text-background-50 md:text-5xl">
            {heroSlides[index].title}
          </h1>
          <p className="mt-2 text-sm text-accent-200 md:text-base">
            {heroSlides[index].subtitle}
          </p>
          <p className="mt-4 max-w-xl text-sm leading-relaxed text-background-100/90 md:text-base">
            {heroSlides[index].desc}
          </p>

          <div className="mt-6 flex flex-col gap-3 sm:flex-row sm:items-center">
            <Link
              to={heroSlides[index].link}
              className="inline-flex items-center justify-center gap-2 rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 dark:text-foreground-950"
            >
              查看详情
              <i className="ri-arrow-right-line"></i>
            </Link>
            <Link
              to="/roles"
              className="inline-flex items-center justify-center gap-2 rounded-md border border-background-100/50 bg-background-50/10 px-6 py-3 text-sm font-medium text-background-50 backdrop-blur transition-colors hover:bg-background-50/20"
            >
              浏览角色库
            </Link>
          </div>

          <form
            onSubmit={handleSearch}
            className="mt-6 flex max-w-md items-center gap-2 rounded-md border border-background-100/40 bg-background-50/95 px-3 py-2 backdrop-blur"
          >
            <i className="ri-search-line text-foreground-500"></i>
            <input
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="输入角色名或资讯关键词快速搜索"
              className="w-full bg-transparent text-sm text-foreground-900 placeholder:text-foreground-500 focus:outline-none"
            />
            <button
              type="submit"
              className="shrink-0 rounded-md bg-primary-500 px-4 py-1.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 cursor-pointer dark:text-foreground-950"
            >
              搜索
            </button>
          </form>
        </div>
      </div>

      <button
        onClick={() => go(-1)}
        aria-label="上一张"
        className="absolute left-3 top-1/2 z-10 hidden h-10 w-10 -translate-y-1/2 items-center justify-center rounded-full border border-background-100/40 bg-background-50/20 text-background-50 backdrop-blur transition-colors hover:bg-background-50/40 md:flex"
      >
        <i className="ri-arrow-left-s-line text-2xl"></i>
      </button>
      <button
        onClick={() => go(1)}
        aria-label="下一张"
        className="absolute right-3 top-1/2 z-10 hidden h-10 w-10 -translate-y-1/2 items-center justify-center rounded-full border border-background-100/40 bg-background-50/20 text-background-50 backdrop-blur transition-colors hover:bg-background-50/40 md:flex"
      >
        <i className="ri-arrow-right-s-line text-2xl"></i>
      </button>

      <div className="absolute bottom-5 left-1/2 z-10 flex -translate-x-1/2 gap-2">
        {heroSlides.map((slide, i) => (
          <button
            key={slide.id}
            onClick={() => setIndex(i)}
            aria-label={`切换到第 ${i + 1} 张`}
            className={`h-2 rounded-full transition-all ${
              i === index ? "w-6 bg-primary-400" : "w-2 bg-background-100/60"
            }`}
          ></button>
        ))}
      </div>
    </section>
  );
}